// extracted by mini-css-extract-plugin
export default {"FAQCardSet":"FAQCardSet_FAQCardSet__5HO5n"};